import { Box, Divider } from "@mui/material";
import { useBudget } from "../../../../contexts/BudgetContext/projectbudgets.context";
import {
  initialBudgetWideAppliedTaxes,
  NFMMOption,
} from "../../../../types/budget/budget";
import { formatCurrency } from "../../../../utils/formatters";
import { useMemo } from "react";
import GlobalAppliedTaxes from "./GlobalAppliedTaxes";
import TotalAccordion from "../../Budget/BudgetTotals/TotalAccordion";
import { useServices } from "../../../../contexts/ServicesContext/projectservices.context";

interface ServiceTotalProps {}

export default function ServiceTotals({}: ServiceTotalProps) {
  //   const { activeBudgetIndex, activeBudget, versionInfo } = useBudget();
  const {  activeService,  } = useServices();
  const optionsArr: NFMMOption[] = ["A", "B", "C", "D"];

  const serviceWideAppliedTaxes = useMemo(() => {
    return (
      activeService.budgetWideAppliedTaxes[0]
    );
  }, [activeService]);
  const extras = serviceWideAppliedTaxes?.taxData.extras.value || 0;
  const extrasType = serviceWideAppliedTaxes?.taxData.extras.typeTax;
  const versionTotals = useMemo(() => {
      return activeService.budgetValuesTotal?.byItemType?.SUM?.totalInBRL || 0;
    
  }, [activeService]);

  const totalsWithExtras =
    extrasType === "PERCENTAGE"
      ? versionTotals + versionTotals * (extras / 100)
      : versionTotals + extras;

  return (
    <Box width={"100%"} gap={1}>
      <Box pb={2}>
        <span style={{ fontSize: "20px", fontWeight: "semi-bold" }}>
          Totais - {activeService.name || `Serviço`}
        </span>
      </Box>
      {optionsArr.map((el) => {
        const services = activeService.budgetServices.filter(
          (service) => service.calcOption === el
        );
        if (services.length < 1 || el === "SUM") return <></>;
        return (
          <TotalAccordion
            type={el}
            totalPerCalcOption={
              activeService.budgetValuesTotal.byCalculationType[el]
            }
            services={services}
          />
        );
      })}

      <Divider />
      <GlobalAppliedTaxes />

      <Box my={2} gap={2}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          fontWeight={"bold"}
          my={1}
        >
          <Box>Total</Box>
          <Box>{formatCurrency(versionTotals)}</Box>
        </Box>
      </Box>
      <Box my={2} gap={2}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          fontWeight={"bold"}
          my={1}
        >
          <Box>Total + Extra</Box>
          <Box>{formatCurrency(totalsWithExtras)}</Box>
        </Box>
      </Box>
    </Box>
  );
}
